import { useQuery } from "@tanstack/react-query";
import { CACHE_KEYS } from "@api/constants/cacheKeys";
import URLS from "@api/constants/urls";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import { useState } from "react";
import { IGetServiceProps } from "@api/types/globalService.types";
import useGlobalDebounceHandler from "./useGlobalDebounceHandler";

export const useGetAllRelationsService = ({
  page = "1",
  per_page = "15",
  enableQuery,
  relationId = "",
}: IGetServiceProps) => {
  const [searchQuery, setSearchQuery] = useState("");
  const { debouncedQuery } = useGlobalDebounceHandler(searchQuery);

  const allRelationsService = useQuery({
    queryKey: [
      ...CACHE_KEYS.RELATIONS,
      page,
      debouncedQuery,
      per_page,
      relationId,
    ],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: URLS.RELATIONS,
        searchParams: {
          page,
          "filter[name]": debouncedQuery,
          "filter[id]": relationId || "",
          per_page,
        },
      }),
    enabled: enableQuery,
  });

  return {
    services: { allRelationsService },
    states: { searchQuery, setSearchQuery },
  };
};
